import $ from 'jquery';
import { Directive, ElementRef, OnInit, OnChanges, Input, OnDestroy } from '@angular/core';

const DEFAULT_POSITION = 'top left';

@Directive({
  selector: '[tooltip]',
  exportAs: 'tooltip',
})
export class TooltipDirective implements OnInit, OnChanges, OnDestroy {
  @Input() public tooltip;
  @Input() public html?;
  @Input() public position;
  @Input() public boundary;
  @Input() public disabled;
  @Input() public delay = 500;
  @Input() public trigger = 'hover';
  @Input() public transition = 'scale';
  @Input() public distanceAway: number = 0;
  @Input() public offset: number = 0;
  @Input() public scrollContext: string;
  @Input() public hideOnScroll: boolean;
  @Input() public variation?: string = 'inverted';
  @Input() public customClassName: 'narrow' | undefined;
  @Input() public targetSelector: string; // allows popup to be positioned relative to given element

  private $el;

  constructor(el: ElementRef) {
    this.$el = $(el.nativeElement);
  }

  public ngOnInit() {
    this.createToolTip();
  }

  public ngOnDestroy() {
    if (this.$el.popup) this.$el.popup('destroy');
  }

  public ngOnChanges(changes) {
    if (changes.tooltip && !changes.tooltip.firstChange) {
      this.$el.popup('destroy');
      this.createToolTip();
    }
  }

  private createToolTip() {
    const position = this.position || DEFAULT_POSITION;
    const boundary = this.boundary || undefined;
    const content = this.html ? undefined : this.tooltip || '';
    const html = this.html || undefined;
    const variation = this.variation;
    const distanceAway: number = this.distanceAway;
    const offset: number = this.offset;
    const scrollContext: string = this.scrollContext || undefined;
    const hideOnScroll: boolean = this.hideOnScroll || undefined;
    const customClassName = this.customClassName || '';
    this.$el.popup({
      variation,
      content,
      className: { popup: `ui popup ${customClassName}` },
      html,
      position,
      boundary,
      distanceAway,
      offset,
      hideOnScroll,
      scrollContext: $(scrollContext),
      target: this.targetSelector,
      delay: {
        show: this.delay,
        hide: 0,
      },
      onShow: () => {
        return !this.disabled;
      },
      on: this.trigger,
      transition: this.transition,
    });
  }
}
